import ConfigProvider from './ConfigProvider';

export default abstract class AbstractConfigProvider implements ConfigProvider {
    /**
     * Config key prefix. E.g. 'foo' will produce config keys like 'foo.bar', 'foo.baz'
     */
    abstract prefix: string;

    /**
     * Return all config values
     */
    abstract getConfig(): { [key: string]: string };

    /**
     * Add new prefixed config value
     */
    protected add(key: string, value: string): { [key: string]: string } {
        return {
            [`${this.prefix.toLowerCase()}.${key}`]: value,
        };
    }
}
